<template>
  <div id="topBar">
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      :color="barColor"
      dark
    >
      <v-app-bar-nav-icon @click.stop="clickNavIcon" />

      <v-toolbar-title
        style="width: 130px; cursor: pointer"
        class="ml-0 pl-4 hidden-sm-and-down"
        @click="$router.push({name: 'dashboard'}).catch((err) => {})"
      >
        <div class="hidden-sm-and-down">
          <v-img
            src="@/assets/branding/gcg_logo.png"
            contain
            height="30"
          />
        </div>
      </v-toolbar-title>

      <v-spacer />

      <!--<Notification />-->

      <!--<v-btn
        class="mx-1"
        icon
        @click="toggleDarkMode"
      >
        <v-icon v-if="$vuetify.theme.dark">
          mdi-brightness-4
        </v-icon>
        <v-icon v-else>
          mdi-brightness-7
        </v-icon>
      </v-btn>-->

      <ServiceSelection class="mr-2" />

      <AccountMenu />
    </v-app-bar>

    <DrawerMenu :style="{ pointerEvents: needPayment ? 'none' : null }" />
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import DrawerMenu from './DrawerMenu.vue';
// import Notification from './Notification.vue';
import AccountMenu from './AccountMenu.vue';
import ServiceSelection from './ServiceSelection.vue';

export default {
  components: {
    DrawerMenu,
    // Notification,
    AccountMenu,
    ServiceSelection,
  },

  props: {
    needPayment: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    notification: false,
  }),

  computed: {
    barColor() {
      if (this.$vuetify.theme.dark) {
        return '';
      }
      return 'primary';
    },
  },

  methods: {
    ...mapMutations('displaySettings', [
      // 'toggleDarkMode',
      'toggleExpandDrawerOnHover',
      'toggleShowDrawer',
    ]),

    clickNavIcon() {
      if (this.$vuetify.breakpoint.lgAndUp) {
        this.toggleExpandDrawerOnHover();
      } else {
        this.toggleShowDrawer();
      }
    },
  },
};
</script>
